'use client';

import { useTranslations } from 'next-intl';
import { HierarchyIcon } from '@terra/ui-icons';
import { Alert } from '../../../components/alert';
import { Button } from '../../../components/button';

export type ManageNetworkSetupCalloutProps = {
  onManageNetworks?: () => void;
};

export function ManageNetworkLinkButton({
  onManageNetworks,
}: {
  onManageNetworks: () => void;
}) {
  const t = useTranslations('designSystem.applicationSettings.networking');

  return (
    <Button
      variant="link"
      size="sm"
      p={0}
      h="auto"
      textDecoration="underline"
      display="inline"
      onClick={onManageNetworks}
    >
      {t('manageNetwork')}
    </Button>
  );
}

export function ManageNetworkSetupCallout({
  onManageNetworks,
}: ManageNetworkSetupCalloutProps) {
  const t = useTranslations('designSystem.applicationSettings.networking');

  return (
    <Alert.Root>
      <Alert.Icon asChild>
        <HierarchyIcon />
      </Alert.Icon>
      <Alert.Content>
        <Alert.Title>{t('description')}</Alert.Title>
        {onManageNetworks ? (
          <Alert.Description>
            <ManageNetworkLinkButton onManageNetworks={onManageNetworks} />
          </Alert.Description>
        ) : null}
      </Alert.Content>
    </Alert.Root>
  );
}
